import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteProductPackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteProductPackage = createAsyncThunk('deleteProductPackage', async (payload) => {
  return await deleteProductPackageApi(payload);
});

const deleteProductPackageSlice = createSlice({
  name: 'deleteProductPackage', // Unique Name
  initialState,
  reducers: {
    deleteProductPackageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteProductPackage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteProductPackage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteProductPackage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteProductPackageReset } = deleteProductPackageSlice.actions;

export default deleteProductPackageSlice.reducer;
